import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

import Production from './views/dashboard/production/Production.vue'
import DhrDetail from './views/dashboard/production/DhrDetail.vue'
import DhrMasterVersion from './views/dashboard/production/MasterVersion.vue'
import DhrMasterDetail from './views/dashboard/production/DhrMasterDetail'
import Master from './views/dashboard/production/Master.vue'
import InProgress from './views/dashboard/production/InProgress.vue'
import Completed from './views/dashboard/production/Completed.vue'
import Approved from './views/dashboard/production/Approved.vue'

import Traceability from './views/dashboard/traceability/Traceability.vue'
import LotTable from './views/dashboard/traceability/LotTable.vue'
import OrderTable from './views/dashboard/traceability/OrderTable.vue'

import Management from './views/dashboard/management/Management.vue'
import RawMaterials from './views/dashboard/management/RawMaterials.vue'
import Devices from './views/dashboard/management/Devices.vue'
import ProductionFlows from './views/dashboard/management/ProductionFlows.vue'
import ProductionSteps from './views/dashboard/management/ProductionSteps.vue'
import Users from './views/dashboard/management/Users.vue'
import Backups from './views/dashboard/management/Backups.vue'

import Login from './views/authentication/Login.vue'
import ForgotPassword from './views/authentication/ForgotPassword.vue'
import HomeDash from './views/dashboard/Home.vue'
import Search from './views/dashboard/Search.vue'

import StartProduction from './views/dashboard/StartProduction.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'forgotpassword',
      component: ForgotPassword
    },
    {
      path: '/',
      alias: '/dashboard',
      name: 'Home',
      component: HomeDash,
      meta: { 
        requiresAuth: true
      },
    },
    {
      path: '/start-production',
      name: 'Start Production',
      component: StartProduction,
      meta: { 
        requiresAuth: true
      },
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: { 
        requiresAuth: true
      },
    },
    {
      path: '/production',
      name: 'Production',
      component: Production,
      meta: { 
        requiresAuth: true
      },
      children: [
        {
          path: 'dhr/:dhrid/:dhrlot',
          name: "DHR Detailed",
          component: DhrDetail,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'dhr/master/version/:deviceref/:deviceid',
          name: "DHR Master",
          component: DhrMasterVersion,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'dhr/master/:deviceref/:deviceid/:flowid',
          name: "DHR Master",
          component: DhrMasterDetail,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'master',
          name: "Master",
          component: Master,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'in-progress',
          name: "In Progress",
          component: InProgress,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'completed',
          name: "Completed",
          component: Completed,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
        {
          path: 'approved',
          name: "Approved",
          component: Approved,
          meta: { 
            requiresAuth: true,
            parent: "Production",
            icon: "folder"
          }
        },
      ]
    },
    {
      path: '/traceability',
      name: 'Traceability',
      component: Traceability,
      children: [
        {
          path: 'lot-table',
          name: 'Lot Table',
          component: LotTable,
          meta: { 
            requiresAuth: true,
            parent: "Traceability",
            icon: "compass"
          }
        },
        {
          path: 'order-table',
          name: "Order Table",
          component: OrderTable,
          meta: { 
            requiresAuth: true,
            parent: "Traceability",
            icon: "compass"
          }
        },
      ],
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/management',
      name: 'Management',
      component: Management,
      children: [
        {
          path: 'raw-materials',
          name: "Raw Materials",
          component: RawMaterials,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
        {
          path: 'devices',
          name: "Devices",
          component: Devices,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
        {
          path: 'production-flows',
          name: "Production Flows",
          component: ProductionFlows,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
        {
          path: 'production-steps',
          name: "Production Steps",
          component: ProductionSteps,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
        {
          path: 'users',
          name: "Users",
          component: Users,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
        {
          path: 'backups',
          name: "Backups",
          component: Backups,
          meta: { 
            requiresAuth: true,
            parent: "Management",
            icon: "user-friends"
          }
        },
      ],
      meta: { 
        requiresAuth: true
      },
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/404',
      name: '404',
      component: require('@/views/base/_404.vue').default,
      props: true,
    },
    {
      path: '*',
      redirect: '404',
    },
  ]
})

router.beforeEach((to, from, next) => {
  localStorage.setItem('lastRoute', from.fullPath);
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@/views/base/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@/views/base/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, {
      data,
      children
    }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}

export default router